import { render } from "./IFinish.vue?vue&type=template&id=efca89ba"
import script from "./IFinish.vue?vue&type=script&lang=js"
export * from "./IFinish.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__